import React from 'react';
import { LuChevronLeft, LuChevronRight, LuCalendarRange } from 'react-icons/lu';
import DateInput from '../../ui/DateInput';
import { nombreMes } from '../../../utils/pdf/cierreMensual';
import { getTodayISO } from '../../../utils/dateUtils';

// Qué se cierra (22-oct-2026): un mes calendario o un período con fechas (el primer pago de
// MODO AGUA fue del 25/09 al 22/10). El período arranca donde terminó el último facturado.

const moverMes = (mes, n) => { const [a, m] = mes.split('-').map(Number); const d = new Date(a, m - 1 + n, 1); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`; };
const FECHA = 'w-full h-10 px-2 rounded-xl bg-panel text-ink text-caption font-bold outline-none';

export default function PeriodoCierre({ mes, onMes, periodo, onPeriodo, esActual, sugeridoDesde }) {
    if (periodo) {
        return (
            <div className="space-y-1.5">
                <div className="grid grid-cols-2 gap-2">
                    <label className="text-label font-bold text-muted">Desde
                        <DateInput value={periodo.desde} onChange={v => v && onPeriodo({ ...periodo, desde: v })} className={FECHA} />
                    </label>
                    <label className="text-label font-bold text-muted">Hasta
                        <DateInput value={periodo.hasta} onChange={v => v && onPeriodo({ ...periodo, hasta: v })} className={FECHA} />
                    </label>
                </div>
                <button type="button" onClick={() => onPeriodo(null)} className="text-label font-black text-secondary underline">Volver a mes completo</button>
            </div>
        );
    }
    return (
        <div className="space-y-1.5">
            <div className="flex items-center gap-2">
                <button type="button" onClick={() => onMes(moverMes(mes, -1))} aria-label="Mes anterior" className="w-10 h-10 rounded-xl bg-chip text-ink flex items-center justify-center active:scale-95"><LuChevronLeft size={18} /></button>
                <p className="flex-1 text-center text-body-lg font-black text-ink">{nombreMes(mes)}</p>
                <button type="button" onClick={() => onMes(moverMes(mes, 1))} disabled={esActual} aria-label="Mes siguiente" className="w-10 h-10 rounded-xl bg-chip text-ink flex items-center justify-center active:scale-95 disabled:opacity-30"><LuChevronRight size={18} /></button>
            </div>
            <button type="button" onClick={() => onPeriodo({ desde: sugeridoDesde || `${mes}-01`, hasta: getTodayISO() })}
                className="w-full flex items-center justify-center gap-1.5 text-label font-black text-secondary underline">
                <LuCalendarRange size={13} /> Elegir fechas (desde – hasta)
            </button>
        </div>
    );
}
